
export const regions = [
    {
      region: "West",
      states: [
        "Alaska",
        "California",
        "Colorado",
        "Hawaii",
        "Idaho",
        "Montana",
        "Nevada",
        "Oregon",
        "Utah",
        "Washington",
        "Wyoming",
      ],
    },
    {
      region: "Midwest",
      states: [
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Michigan",
        "Minnesota",
        "Missouri",
        "Nebraska",
        "North Dakota",
        "Ohio",
        "South Dakota",
        "Wisconsin",
      ],
    },
    {
      region: "Southwest",
      states: ["Arizona", "New Mexico", "Oklahoma", "Texas"],
    },
    {
      region: "Southeast",
      states: [
        "Alabama",
        "Arkansas",
        "Delaware",
        "Florida",
        "Georgia",
        "Kentucky",
        "Louisiana",
        "Maryland",
        "Mississippi",
        "North Carolina",
        "South Carolina",
        "Tennessee",
        "Virginia",
        "West Virginia",
      ],
    },
    {
      region: "Northeast",
      states: [
        "Connecticut",
        "Maine",
        "Massachusetts",
        "New Hampshire",
        "New Jersey",
        "New York",
        "Pennsylvania",
        "Rhode Island",
        "Vermont",
      ],
    },
  ];


  export const PERIODS = [{
    id: -100,
    value: 'In person tutoring '
  },
  {
    id: -99,
    value: 'After-school-tutoring'
  },
  {
    id: -98,
    value: 'Summer tutoring'
  },
  {
    id: -97,
    value: 'Winter-tutoring'
  }]
  
  export const subjects = [
    { id: 1, title: 'Math' },
    { id: 2, title: 'ELA' },
    { id: 3, title: 'Science' },
    { id: 4, title: 'Social Studies' },
    { id: 7, title: 'Art' },
    { id: 8, title: 'Music' },
    { id: 10, title: 'Computer Science' },
    { id: 13, title: 'Economics' },
]; 

export const validDays = ['MON','TUE','WED','THU','FRI','SAT','SUN'];

export const TUTOR = "TUTOR"
export const ADMIN = "ADMIN"
export const ROOT = "ROOT"

export const DONE = "DONE"
export const RETRY = "RETRY"
export const PENDING = "PENDING"
export const ERROR = "ERROR"

export const SESSIONS = "sessions"
export const GRADER = "grader"
export const ASSESSMENT_SESSION_ID="assessment_session_id"

export const SAMPLE_DATA =  [
  { month: "Jan", assessments: 120 },
  { month: "Feb", assessments: 150 },
  { month: "Mar", assessments: 200 },
  { month: "Apr", assessments: 180 },
  { month: "May", assessments: 220 },
  { month: "Jun", assessments: 250 },
]

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const VALID_WORK_WEEK = ['MON','TUE','WED','THU','FRI','SAT','SUN'];

export const AWS_LINK = "https://api.presentifyclone.click";
export const DEV_LINK = "http://localhost:3333"
export const STATUS_OK = 200;